export const fastlyIoUrl = (src: string, params = ""): string => {
  const imagePath = src.replace(/images.(ctfassets.net|contentful.com)/, "www.fastly.com/cimages")

  return imagePath.includes(".svg") ? imagePath : imagePath + params
}
